module.exports = __webpack_public_path__ + "img/team-map-position.9829f896.png";